import React, { useCallback, useContext } from 'react';
import MouseContext from '../../context/MouseContext';
import styled from 'styled-components';
import profileImage from '../../assets/images/Himanshu_-_Profile-removebg-preview.png';
import { motion } from 'framer-motion';

function Profile() {

//   const { cursorChangeHandler } = useContext(MouseContext);

//   const cursorChangeLinkedInHandler = useCallback(() => {
//     cursorChangeHandler("LinkedIn");
//     // console.log('enter')
//   }, [cursorChangeHandler]);

//   const cursorChangeEmptyHandler = useCallback(() => {
//     cursorChangeHandler("");
//     // console.log('out')
//   }, [cursorChangeHandler]);

  return (
    <ProfileContainer 
    //   onMouseEnter={cursorChangeLinkedInHandler} 
    //   onMouseLeave={cursorChangeEmptyHandler}
    //   onClick={() => window.open('https://www.linkedin.com/in/himanshu-bhoir-34a9a01b9/','_blank')}
    >
      <ProfileContent>
        <ProfileDetails>
          <Name>Himanshu Bhoir</Name>
          <Title>Web Development Expert</Title>
          <Info>Bachelor's of Engineering, Computer, 8.95</Info>
          <Info>University of Mumbai</Info>
          <Info>Leetcode Knight, Top 5% Programmers</Info>
        </ProfileDetails>
        <ProfileImage  
          whileHover={{ scale: 1.1 }} 
          whileTap={{ scale: 0.9 }} 
          transition={{ type: "spring", stiffness: 400, damping: 15 }} 
        />
      </ProfileContent>
    </ProfileContainer>
  );
}

export default Profile;

const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  /* height: 40vh; */
  background-color: #ffffffb4; 
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
`;

const ProfileContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const ProfileImage = styled(motion.div)`
  height: 10vw;
  width: 10vw;
  border-radius: 50%;
  background-image: url(${profileImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: gray;
  margin-left: auto;
  filter: saturate(10%);
  transition: filter 3s ease-in-out;
  &:hover{
    filter: saturate(100%);
  }
`;

const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-right: 20px;
`;

const Name = styled.h1`
  font-size: 7vw;
  font-weight: 500px;
  color: black;
  margin: 0;
`;

const Title = styled.h2`
  font-size: 1.5em;
  color: #4d4c4c;
  margin: 5px 0;
`;

const Info = styled.p`
  font-size: 1.2em;
  color: #4d4c4c;
  margin: 2px 0;
`;
